module.exports = {
  emptyMessage: 'Faltou uma informação aqui! Preencha com o nome que aparece em seu cartão.',
  containsNumberMessage: 'Ei, o nome não pode conter números.',
  maxLengthMessage: 'Ops! Você excedeu o número de caracteres permitidos, preencha novamente.',
  defaultMessage: 'Ops! O nome informado é inválido.',
};
